// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const FormWrapper = styled.form`
  padding: 1em;

  display: -ms-grid;
  -ms-grid-columns: (1fr 1em)[4] 1fr;
  -ms-grid-rows: (auto 1em)[2] auto;

  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
  grid-template-areas:
    "errors-list errors-list  errors-list   errors-list errors-list"
    "site-name   call-sign    asr           contact     submit"
    "latitude    longitude    radius        .           clear";
  grid-template-columns: repeat(4, 1fr) 1fr;
  grid-template-rows: repeat(3, auto);

  /* comes from <SubmitErrors /> */
  > .errors-list-wrapper {
    grid-area: errors-list;
    -ms-grid-column: 1;
    -ms-grid-column-span: 9;
    -ms-grid-row: 1;
  }

  > .site-name {
    grid-area: site-name;
    -ms-grid-column: 1;
    -ms-grid-row: 3;
  }

  > .call-sign {
    grid-area: call-sign;
    -ms-grid-column: 3;
    -ms-grid-row: 3;
  }

  > .asr {
    grid-area: asr;
    -ms-grid-column: 5;
    -ms-grid-row: 3;
  }

  > .contact {
    grid-area: contact;
    -ms-grid-column: 7;
    -ms-grid-row: 3;
  }

  > .submit {
    grid-area: submit;
    -ms-grid-column: 9;
    -ms-grid-row: 3;

    // to account for heading/label height in input fields
    margin-top: 1.35em;
  }

  > .latitude {
    grid-area: latitude;
    -ms-grid-column: 1;
    -ms-grid-row: 5;
  }


  > .longitude {
    grid-area: longitude;
    -ms-grid-column: 3;
    -ms-grid-row: 5;
  }

  > .radius {
    grid-area: radius;
    -ms-grid-column: 7;
    -ms-grid-row: 5;
  }

  > .clear {
    grid-area: clear;
    -ms-grid-column: 9;
    -ms-grid-row: 5;

    // to account for heading/label height in input fields
    margin-top: 1.35em;
  }
`
